import AbstractComponent from "./abstractComponent";

export default class VideoModal extends AbstractComponent {
  /**
   * @param {string} element - Selector
   * @param {Object} options - User options
   */
  constructor(element, options) {
    super(options);
    this.element = element || ".js-trigger-video-modal";

    window.addEventListener("DOMContentLoaded", () => {
      this.init();
    });
  }

  /**
   * Init
   */
  init() {
    if (document.querySelectorAll(this.element).length === 0) {
      return;
    }

    function toggle_video_modal() {
      // Click on video thumbnail or link
      jQuery(".js-trigger-video-modal").on("click", function (e) {
        // prevent default behavior for a-tags, button tags, etc.
        e.preventDefault();

        // Grab the video ID from the element clicked
        const id = jQuery(this).attr("data-youtube-id");

        // Autoplay when the modal appears
        // Note: this is intetnionally disabled on most mobile devices
        // If critical on mobile, then some alternate method is needed

        // String the ID and param variables together
        const src = `//www.youtube.com/embed/${id}?playlist=${id}&loop=1;rel=0&autoplay=1&controls=1&showinfo=0&modestbranding=1&theme=dark&fs=0&iv_load_policy=3`;

        // Pass the YouTube video ID into the iframe template...
        // Set the source on the iframe to match the video ID
        jQuery("#youtube").attr("src", src);

        // Add class to the body to visually reveal the modal
        jQuery("body").addClass("show-video-modal overflow-hidden");
      });

      // Close and Reset the Video Modal
      function close_video_modal() {
        event.preventDefault();

        // re-hide the video modal
        jQuery("body").removeClass("show-video-modal overflow-hidden");

        // reset the source attribute for the iframe template, kills the video
        jQuery("#youtube").attr("src", "");
      }
      // if the 'close' button/element, or the overlay are clicked
      jQuery("body").on(
        "click",
        ".close-video-modal, .video-modal .overlay",
        (event) => {
          // call the close and reset function
          close_video_modal();
        }
      );
      // if the ESC key is tapped
      jQuery("body").keyup((e) => {
        // ESC key maps to keycode `27`
        if (e.keyCode == 27) {
          // call the close and reset function
          close_video_modal();
        }
      });
    }
    toggle_video_modal();
  }
}
